/**
 * Calculate a nice set of options for axis step sizes given the data min and max values.
 * @param min
 * @param max
 * @returns {number[]}
 */
export function getDefaultStepOptions(min, max) {

	const dataRange = max - min;

	if (dataRange === 0) {
		return [1];
	}

	const multipliers = [1, 2, 2.5, 5];
	const startPower = Math.floor(Math.log(dataRange / 20) / Math.log(10));

	let i = 0;
	let pow = startPower;
	let opt = multipliers[i] * Math.pow(10, pow);

	const stepOpts = [];

	while (opt <= dataRange) {

		stepOpts.push(opt);

		if (++i === multipliers.length) {
			i = 0;
			pow++;
		}

		opt = multipliers[i] * Math.pow(10, pow);

	}

	return stepOpts;

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/get-default-step-options.js